$(document).ready(function () {

    $('[data-timestamp]').each(function () {
        const timestamp = $(this).data('timestamp');

        const formatted = new Intl.DateTimeFormat(undefined, {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }).format(new Date(timestamp));

        $(this).text(formatted);
    });

    if(window.smeg && window.smeg.courses){
        $('#calendar-container').simpleCalendar({
                events: window.smeg.courses.events,
            }
        );
    }

});